import { WorkflowTypeEnum } from "@src/models/enums/WorkflowTypeEnum";
import { IBuyGiftCustomizeStepProps } from "@src/models/props/CustomizeStepProps.interface";
import React, { useState } from "react";
import { RegiftCardStateEnum } from "../../models/enums/RegiftCardStateEnum";
import { RegiftCardContext } from "../../pages/RegiftCardPage";
import CustomizeStep from "./shared/CustomizeStep";
import { CheckBalanceStepModel } from "../../models/CheckBalanceStep.model";
import { RegiftCardStepModel } from "../../models/RegiftCardStep.model";
import { RecipientsStepModel } from "../../models/RecipientsStep.model";

const RegiftCardCustomizeStep = (props: IBuyGiftCustomizeStepProps) => {

    const { id, currentState, checkBalanceStep, regiftCardStep, recipientsStep, customizeStep } = React.useContext(RegiftCardContext);
    const [error, setError] = useState(null);

    const [model, setModel] = useState(customizeStep);

    const IS_ACTIVE = (checkBalanceStep && CheckBalanceStepModel.validateModel(checkBalanceStep) && !checkBalanceStep.isDirty)
        && (regiftCardStep && RegiftCardStepModel.validateModel(regiftCardStep, checkBalanceStep.remainingBalance) && !regiftCardStep.isDirty)
        && (recipientsStep && RecipientsStepModel.validateModel(recipientsStep, WorkflowTypeEnum.REGIFT_CARD) && !recipientsStep.isDirty);

    if (error) throw error;
    return (
        <>
            {!props.isSaving &&
                <CustomizeStep
                    basketId={id}
                    isSaving={props.isSaving}
                    isActive={IS_ACTIVE}
                    model={model}

                    workflowType={WorkflowTypeEnum.BUY_GIFT_CARD}
                    expanded={currentState == RegiftCardStateEnum.CUSTOMIZE_CARD}

                    handleTemplateChange={props.handleTemplateChange}
                    handleMediaChange={props.handleMediaChange}
                    hasRequestToSaveBasket={props.hasRequestToSaveBasket}
                    handleDirtyState={props.handleDirtyState}
                    handleSubmit={props.handleSubmit}
                    handlePreview={props.handlePreview}
                    handleBeginEdit={props.handleBeginEdit}
                />}
        </>
    )
}

export default RegiftCardCustomizeStep;